// Production
export const SERVER = 'https://api.vieutopia.com'

// TEST
// export const SERVER = 'http://192.168.1.233:8000'